import { create } from 'zustand';
import { devtools, persist } from 'zustand/middleware';

interface WhatsNewStore {
  showPopup: boolean;
  lastSeenVersion: string | null;
  checkForUpdates: (latestVersion: string) => void;
  dismissPopup: (version: string) => void;
}

export const useWhatsNewStore = create<WhatsNewStore>()(
  devtools(
    persist(
      (set, get) => ({
        showPopup: false,
        lastSeenVersion: null,

        checkForUpdates: (latestVersion: string) => {
          const { lastSeenVersion } = get();
          if (lastSeenVersion !== latestVersion) {
            set({ showPopup: true });
          }
        },

        dismissPopup: (version: string) => {
          set({ showPopup: false, lastSeenVersion: version });
        },
      }),
      {
        name: 'whats-new-store',
        partialize: (state) => ({ lastSeenVersion: state.lastSeenVersion }),
      }
    ),
    { name: 'whats-new-store' }
  )
);
